import cn from 'classnames';
import React from 'react';
import {useSelector} from 'react-redux';

import deviceTypesService from '../../../services/device/deviceTypesService';
import {selectIotDeviceData, selectIsDeviceConnected} from '../../../state/selectors/iotDevice';
import {getState} from '../../../state/store';
import styles from './Logs.module.css';

const CopyDeviceInfoButton = ({className}) => {
    const isDeviceConnected = useSelector(selectIsDeviceConnected);

    const onClick = () => {
        if (!isDeviceConnected) return;

        getDeviceInfo();
    };

    return (
        <div
            onClick={onClick}
            className={cn(className, styles.ClearLogsBtn, {'cursor-default border-grey text-grey': !isDeviceConnected})}
        >
            Copy device info
        </div>
    );
};

export default CopyDeviceInfoButton;

const getDeviceInfo = async () => {
    const state = getState();
    const {device, device_engine, holder, holder_engine} = selectIotDeviceData(state);

    const infoList = [];

    if (device) infoList.push(getDeviceOrHolderTargetInfo(device));
    if (device_engine) infoList.push(getTargetInfo(device_engine));
    if (holder) infoList.push(getDeviceOrHolderTargetInfo(holder));
    if (holder_engine) infoList.push(getTargetInfo(holder_engine));

    const result = infoList.join('');

    try {
        await navigator.clipboard.writeText(result);
    } finally {
        console.log(result);
    }
};

const getDeviceOrHolderTargetInfo = ({codentifyOriginal, deviceSerialNumber, version, type}) => {
    const modelName = deviceTypesService.getDeviceModelNameByType(type);

    return `${modelName}
        ${type} ${codentifyOriginal} ${deviceSerialNumber} ${version}
`;
};

const getTargetInfo = ({deviceTypeName, serialNumber, firmwareVersion}) => {
    return `        ${deviceTypeName} ${serialNumber} ${firmwareVersion}`;
};
